module.exports = __webpack_public_path__ + "static/media/education-min.d8ca271c.jpg";